import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar';
import axios from 'axios';
import { toast } from 'react-toastify';
import { MdAssignmentTurnedIn } from "react-icons/md";
import { Button, Input, Select, Table } from 'antd';
import '../App.css';
import { Option } from 'antd/es/mentions';

import { CustomerMasterFindAll, getYearList, OpeningBalanceAdd, OpeningBalanceDelete, OpeningBalanceFindAll, OpeningBalanceUpdate, UserMasterGetAll } from '../Api/All_Api';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import TitleNavbar from '../Navbar/TitleNavbar';
import { GiExpense } from 'react-icons/gi';

const OpeningBalance = () => {

  const sessionYear = sessionStorage.getItem('sessionYear');
  const year = sessionYear
  const branchId = sessionStorage.getItem('branchId');
  const isAdmin = sessionStorage.getItem('role');   
  // console.log("Role",isAdmin);
const navigate = useNavigate();

    useEffect(() => {
      if (!sessionYear) {
        sessionStorage.clear();
        navigate('/')
      }
    },[])


  const [errors, setErrors] = useState({
    customer: "",
    AccYear: "",
    amount:"",
  });

  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [BalanceId, setBalanceId] = useState("");
  const [customer, setCustomer] = useState("");
  const [AccYear, setAccYear] = useState("");
  const [allCustomer, setAllCustomer] = useState([]);
  const [allYears, setAllYears] = useState([]);
  const [allBalance, setAllBalance] = useState([]);
   const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);
  const[amount,setAmount]= useState("");

    //======Search data from table===============
    const handleSearch = (value) => {
      const filtered = allBalance.filter((item) =>
        Object.values(item).some((val) =>
          val !== null && val !== undefined && val.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };

  // Fetch Cast Names
 
  useEffect(() => {
  fetchCustomerNames();
  fetchBalance();
 // fetchYears();
  }, []);

  const fetchCustomerNames = async () => {
  
    try {
      const response = await axios.get(`${CustomerMasterFindAll}?branchId=${branchId}`);
      if (response.data !== null) {
        setAllCustomer(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customers:", error);
        toast.error("Failed to fetch customers data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  // const fetchYears = async () => {
  
  //   try {
  //     const response = await axios.get(getYearList);
  //     if (response.data !== null) {
  //       setAllYears(response.data);
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error("Error fetching Years:", error);
  //       toast.error("Failed to fetch Years data");
  //       isError = true; // Set the flag to prevent double toast
  //     }
  //   }
  // };


  // ==============Get table data================

  let isError = false;

  const fetchBalance = async () => {
 
    try {
      
      const response = await axios.get(`${OpeningBalanceFindAll}?branchId=${branchId}&accYear=${year}`);
      if (response.data !== null) {
        setAllBalance(response.data);
        setFilteredData(response.data); // Set initial filtered data as the fetched data
        setTotalEntries(response.data.length); // Set the total number of entries
      }
    } catch (error) {
      if (!isError) {
        // Check if the error has already been triggered
        console.error("Error fetching Balance:", error);
        toast.error("Failed to fetch Balance");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Amount",
      dataIndex: "pendingAmount",
      key: "pendingAmount",
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <div>
          <span
            type="submit"
            id={`edit-tooltip-${record.id}`}
            style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
            onClick={() => handleEditData(record)}
          >
            <i className="fa-solid fa-edit"></i>
          </span>
          <Tooltip
            anchorId={`edit-tooltip-${record.id}`}
            content="Edit"
            place="top"
          />
        </div>
      ),
    },
    

    ...(isAdmin === "1" ? [{
      title: "Delete",
      key: "delete",
      render: (text, record) => (
        <div>
          <span
            type="submit"
            id={`delete-tooltip-${record.id}`}
            style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
            onClick={() => handleDeleteData(record)}
          >
            <i className="fa-solid fa-trash"></i>
          </span>
          <Tooltip
            anchorId={`delete-tooltip-${record.id}`}
            content="Delete"
            place="top"
          />
        </div>
      ),
    }] : []),
 
  ];
  

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };

  // ========Cancel data save==================
  const handleCancel = () => {
    setCustomer("");
    setAccYear("");
    setAmount("");
    setErrors("");
    setUpdateButton(false);
    setSaveButton(true);
    fetchBalance();
  };

  // ========Submit data to table==============
 
  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};
  
   
    if (!customer) {
      isValid = false;
      errorObj.customer = "Customer Name is required *";
    }
    if (!AccYear) {
      isValid = false;
      errorObj.AccYear = "Year is required *";
    }
    if (!amount) {
      isValid = false;
      errorObj.AccYear = "Amount is required *";
    }
  
    setErrors(errorObj); // Set error messages
  
    if (!isValid) return;
  
    const bodyData = {
      customerId:customer,
      pendingAmount:parseFloat(amount),
      year:AccYear,
      accYear:parseInt(year),
      branchId:parseInt(branchId),
    };
  
    try {
      const response = await axios.post( OpeningBalanceAdd,bodyData);
  
      if (response.data === "SAVED") {
        toast.success("Saved Successfully!");
        fetchBalance();
        handleCancel();
    }
  
        // Call the second API and pass the status
       if (response.data === "ALREADYEXISTS") {
        toast.warn(" Already Exists!");
        handleCancel();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }
  };

  // ========Update data from table============
  const handleEditData = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    window.scrollTo(0, 0);
    setCustomer(item.customerId);
    setAccYear(item.year);
    setAmount(item.pendingAmount);
    setBalanceId(item.id);
   
  };

  const handleUpdate = async () => {
    let isValid = true;
    const errorObj = {};

    if (!customer) {
      isValid = false;
      errorObj.customer = "Customer Name is required *";
    }
    if (!AccYear) {
      isValid = false;
      errorObj.AccYear = "Year is required *";
    }
    if (!amount) {
      isValid = false;
      errorObj.AccYear = "Amount is required *";
    }

    setErrors(errorObj); // Set error messages

    if (!isValid) return;

    const bodyData = {
      id:BalanceId,
      customerId:customer,
      pendingAmount:parseFloat(amount),
      year:AccYear,
      accYear:parseInt(year),
      branchId:parseInt(branchId),
    };

    try {
      const response = await axios.put(OpeningBalanceUpdate,bodyData);

      if (response.data === "UPDATED") {
        toast.success("Balance Updated!");
        fetchBalance();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn(" Already Assigned!");
        handleCancel();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while updating data");
    }
  };

  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Customer"${item.customerName}"?`
    );
    if (!confirmDelete) return;

    try {
       
      const response = await axios.delete(
        `${OpeningBalanceDelete}?id=${item.id}`
     );
      if (response.data === "DELETED") {
        toast.success(" Deleted !");
        fetchBalance();
      }
    } catch (error) {
      console.error("Error during delete operation:", error);
      toast.error("Error occurred while deleting ");
    }
  };

//===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

  return (
    <>
      <AdminNavbar />

    <div className="p-0 m-0">
        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12 "
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
              <span className="px-md-5" style={{ flexGrow: 1}}>
                {" "}
                <GiExpense /> &nbsp; Opening Balance
              </span>
              <span >
            <TitleNavbar />
            </span>
          </div>

  
        </div>

        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels">Customer :</label>
                    </div>
                    <div className="col-9 col-lg-6">
                         <Select
                                             value={customer || undefined}
                                             onChange={setCustomer}
                                                 showSearch
                                            className="w-100"
                                           placeholder="Select Customer"
                                             optionFilterProp="children">
                                                      {allCustomer.map(p => (
                                                        <Select.Option key={p.id} value={p.id}>
                                                          {p.customerName}
                                                        </Select.Option>
                                                      ))}
                                                    </Select>
                      {errors.customer && (
                        <div className="errorField">{errors.customer}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels">Year :</label>
                    </div>
                    <div className="col-9 col-lg-4">
                    <Input
                                   value={AccYear || undefined}
                                    onChange={(e) => setAccYear(e.target.value)} 
                                            maxLength={4}
                                            className="w-100"
                                           placeholder="Enter Year"
                                            />
                                                  
                      {errors.AccYear && (
                        <div className="errorField">{errors.AccYear}</div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels">Pending Amount :</label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <Input
                    value={amount}
                   onChange={(e) => setAmount(e.target.value)}  // Corrected here
                  type="number"
                  className="w-100"
                 placeholder="Enter Amount"
                    />
                        
                     
                      {errors.amount && (
                        <div className="errorField">{errors.amount}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                   {saveButton && ( 
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleSubmit}
                  >
                    Save
                  </Button>
                  )} 
                  {updateButton && (
                    <Button
                      type="submit"
                      className="UpdateBtn mx-1"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>
              </div>
          </div>
          <div className='col-12 col-md-2 col-lg-4'></div>
        </div>
        {/*================ Table =========================*/}
        <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
        <div className='col-12 col-md-2'></div>
          <div  className="col-12 col-md-8 py-3 shadow border"
            style={{ marginBottom: "50px", backgroundColor: "white" }}
          >
            <div
              className="col-12 px-md-5"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                <Select
                  defaultValue={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: 120, textAlign: "center" }}
                >
                  <Option value={10}>10</Option>
                  <Option value={20}>20</Option>
                  <Option value={30}>30</Option>
                </Select>
              </div>

              <div className="pt-4 pt-md-0">
                <Input.Search
                  placeholder="Search"
                  onSearch={handleSearch}
                  style={{ width: 200, marginBottom: 16 }}
                />
              </div>
            </div>

            <div style={{ backgroundColor: "white" }}>
              <Table
                bordered
                style={{ padding: "0px 20px", overflowX: "auto" }}
                columns={columns}
                dataSource={filteredData}
                pagination={{
                  pageSize: pageSize,
                  total: totalEntries,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  current: currentPage,
                  onChange: (page) => setCurrentPage(page),
                }}
                showSorterTooltip={false}
                rowKey={(record) => record.id}
                components={components}
              />
            </div>
          </div>
          <div className='col-12 col-md-2'></div>
        </div>
      </div>

    </>
  )
}

export default OpeningBalance